export default {"src":"/_next/static/media/hero_m_blue.838a618a.svg","height":459,"width":334,"blurWidth":0,"blurHeight":0};